const getSourceSet = (imageConfigurations, imageUrls) => (
  imageUrls.slice(1).map(
    (imageUrl, index) => (`${imageUrl} ${
      imageConfigurations[index + 1].width}w`),
  ).join(', ')
);

export default getSourceSet;
